import { FooterHandler } from "./Footer/Footer";
import Navbar from 'react-bootstrap/Navbar';
import './nav_bar.css'
import { Button, Col, Row, Space, Spin, Typography } from "antd";
import './landing.css'
import logo from "../assets/Logo/logosidetext.png"
import lasermet from "../assets/Logo/lasermet.png"
import ReactPlayer from "react-player";
import EmblaCarousel from "./EmblaCarousel";
import { NavLink, useNavigate } from "react-router-dom";
import useAuth from '../routes/useAuth'
import { ArrowRightOutlined } from "@ant-design/icons";
import LandingPageNavbar from "./LandingPageNavbar";

export function LandingPage() {
    const { isFetching, isVerified } = useAuth()
    const navigate = useNavigate()


    return (
        <>
            <LandingPageNavbar />
            <Row className='background' style={{ minHeight: "100vh", display: "flex" }}>
                <Row className="content1" style={{ width: "100%", maxWidth: "1280px" }} gutter={[0, 32]}>
                    <Col className="info-group1" xl={12} sm={24} style={{ justifySelf: "center" }}>
                        <h1>
                            Online Laser Safety Calculation Software to IEC 60825-1
                        </h1>
                        <div className="space" />
                        <div style={{ width: "90%" }}>
                            <h6>
                                Realtime LSS is the easy-to-use online laser safety calculator, fully compliant with international standard IEC 60825-1: Safety of Laser Products - Part 1.
                            </h6>
                            <div className="space" />
                            <div className="button-group">
                                <Col lg={11} md={11} xs={20} sm={20}>
                                    {/* <NavLink to="/login"> */}
                                    <Button className="mainButton" type="primary"
                                        onClick={() => {
                                            if (isVerified) {
                                                navigate('/home', { state: { fromWelcomePage: true } })
                                            } else {
                                                navigate('/login')
                                            }
                                        }}
                                        style={{fontWeight: "500"}}
                                    >
                                        Try it now
                                    </Button>
                                    {/* </NavLink> */}
                                </Col>

                                <Col lg={11} md={11} xs={20} sm={20}>
                                    <NavLink to="/pricing-landing">
                                        <Button className="mainButton" style={{ backgroundColor: "white", color: "#1D1F8C", fontWeight:"500" }}>
                                            View Pricing
                                        </Button>
                                    </NavLink>
                                </Col>
                            </div>

                        </div>
                    </Col>
                    <div className="embla-space" />
                    <Col xl={12} sm={24}>
                        <EmblaCarousel />
                    </Col>
                </Row>
            </Row>

            <Row className="content2" style={{ width: "100%", maxWidth: "1280px", height: "auto", display: "flex", backgroundColor: "white", justifyContent: "center", justifySelf: "center" }}>

                <Col xl={14} sm={24} xs={24}>
                    <div className='player-wrapper' style={{ justifyItems: "center", }}>
                        <ReactPlayer
                            className='react-player'
                            url="https://www.youtube.com/watch?v=AuJb3WLqDW8"
                            controls
                            width={780}
                            height={411}
                            style={{ maxWidth: "100%" }}
                        />
                    </div>
                </Col>
                <Col xl={10} sm={24} xs={24} style={{ padding: "24px", marginTop: "-40px" }}>
                    {/* <img src={logo} alt='Realtime LSS logo' width={400} /> */}
                    <div style={{ justifyContent: "center", margin: "40px 0 0 0" }}>
                        <p>RealTime LSS provides on-the-go access, making it ideal for quick assessments whether in the lab or in the field.</p>
                    </div>
                    <div style={{ margin: "15px 0px 15px 0px" }}>
                        <p>Calculate important laser safety parameters, including:</p>
                    </div>
                    <div style={{ padding: "0px 0px 0px 8px" }}>
                        <ul class="custom-ul">
                            <li>
                                Maximum Permissible Exposure (MPE) calculation
                            </li>
                            <li>
                                Accessible Emission Limits (AEL) calculation
                            </li>
                            <li>
                                Laser Classification
                            </li>
                            <li>
                                Diffuse Reflection calculations
                            </li>
                            <li>
                                Fiber Optic Assessments
                            </li>
                        </ul>
                    </div>
                    <Button type="primary" href="/login" style={{ borderRadius: "0px", width: "40%", marginTop: "20px", textDecoration: "none" }}>
                        Try it now
                    </Button>
                </Col>
            </Row>

            <Row style={{ width: "100%", maxWidth: "1280px", height: "auto", backgroundColor: "white", justifyContent: "center", display: "flex", justifySelf: "center", paddingTop: "144px" }}>
                <div style={{ paddingRight: "16px" }}>
                    <img src={lasermet} alt="Lasermet logo" width={300} />
                </div>

                <div className="RTLSSbox">
                    <div>
                        RealTime LSS is developed by Lasermet, a globally recognized authority in laser safety. With decades of experience in laser safety standards, consultancy, and technology.
                        Lasermet provides trusted solutions for ensuring compliance with IEC-60825-1 and other internationl regulations.
                    </div>
                    <Row style={{ marginTop: "20px" }}>
                        <Col xl={10}>

                        </Col>
                        <Col xl={14}>
                            <Button href={"https://www.lasermet.com/"} target="_blank" style={{ textDecoration: "none", borderColor: "#1D1F8C", color: "#1D1F8C", borderRadius: "0px", backgroundColor: "transparent", }}>
                                Visit Lasermet
                            </Button>

                        </Col>
                    </Row>
                </div>

            </Row>
            <FooterHandler />
        </>
    )
}


